export enum ButtonVariants {
  CIRCULAR = 'circular',
}
